const twitter = {
  slug: 'socials/twitter',
  getOAuthUrl: () => `${twitter.slug}/oauth-url`
}

export default twitter
